import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";

import PrintDoc from "../appComponents/PrintDoc";
//import ModalReceipt from "./ModalReceipt";

const Modal = (props) => {
  // Encrypt Decrypt Data //
  const encrypt = (encrypDycrypData, type) => {
    let result;
    if (type === "Encrypt") {
      result = window.btoa(encrypDycrypData);
    } else if (type === "Decrypt") {
      result = window.atob(encrypDycrypData);
    }
    return result;
  };

  let PATH = window.location.origin;

  const [closeModal, setCloseModal] = useState(false);

  const closeModalRef = useRef();

  let tagName;

  switch (props.modalType) {
    case "ModalPaySlips":
      //I added fileNumber to editpost which has only date
      props.searchDate.fileNumber = props.editpost.fileNumber;
      tagName = (
        <PrintDoc
          docType={"ModalPaySlips"}
          title={"PaySlip"}
          id={props.editpost}
          //initializeSearchDate = { startDate: startDate, endDate: endDate };
          datesUseds={props.searchDate}
          referenceNo={
            PATH +
            "/verifypayslip?payload=" +
            encrypt(
              props.searchDate.fileNumber +
                "/" +
                props.searchDate.startDate +
                "/" +
                props.searchDate.endDate,
              "Encrypt"
            )
          }
        />
      );
      break;

    // case "ModalPayBill": //for acknolagement
    //   tagName = (
    //     <ModalReceipt
    //       docType={"ModalPayBill"}
    //       title={"PayBill"}
    //       id={props.editpost}
    //       refreshScreen={props.refreshScreen}
    //       referenceNo={
    //         PATH +
    //         "/verifypaybill?payload=" +
    //         encrypt(props.editpost.invoiceNo, "Encrypt")
    //       }
    //     />
    //   );
    //   break;

    // case "ModalReceipt": //for printing
    //   tagName = (
    //     <PrintDoc
    //       docType={"ModalPayBill"}
    //       title={"PayBill"}
    //       id={props.editpost}
    //       referenceNo={
    //         PATH +
    //         "/verifypaybill?payload=" +
    //         encrypt(props.editpost.invoiceNo, "Encrypt")
    //       }
    //     />
    //   );
    //   break;

    // case "ModalUserRegisterDetails":
    //   tagName = (
    //     <PrintDoc
    //       docType={"ModalUserRegisterDetails"}
    //       title={"Attendance Register"}
    //       id={props.editpost}
    //       datesUseds={props.searchDate}
    //       referenceNo={
    //         PATH +
    //         "/verifyregistry?payload=" +
    //         encrypt(
    //           props.searchScript +
    //             "fileNumber[eq]=" +
    //             props.editpost.fileNumber,
    //           "Encrypt"
    //         )
    //       }
    //     />
    //   );
    //   break;

    // case "ModalReportSheet":
    //   tagName = (
    //     <PrintDoc
    //       docType={"ModalReportSheet"}
    //       title={"Salary Breakdown Sheet"}
    //       id={props.searchScript}
    //       datesUseds={props.searchDate}
    //       referenceNo={
    //         PATH +
    //         "/verifyreportsheet?payload=" +
    //         encrypt(props.searchScript, "Encrypt")
    //       }
    //     />
    //   );
    //   break;

    // case "ModalRegisterDetails":
    //   tagName = (
    //     <PrintDoc
    //       docType={"ModalRegisterDetails"}
    //       title={"Attendance Register"}
    //       id={props.editpost}
    //       datesUseds={props.searchDate}
    //       referenceNo={
    //         PATH +
    //         "/verifyregistry?payload=" +
    //         encrypt(props.searchScript, "Encrypt")
    //       }
    //     />
    //   );
    //   break;

    default:
  }

  if (closeModal === true) {
    closeModalRef.current?.click();
    props.formCleanner();
    setCloseModal(false);
  }

  return props.trigger ? (
    <>
      <div
        className="modal fade"
        id="exampleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {props.titles}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                ref={closeModalRef}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="container-lg-fluid m-3">{tagName}</div>
            </div>
            <div className="modal-footer">
              <Link
                type="button"
                className="btn btn-secondary"
                to="#"
                data-dismiss="modal"
                ref={closeModalRef}
              >
                Close
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    ""
  );
};

export default Modal;
